//记得在 src\components\lang\zhLoad.js 里面添加对象
const vehicleQueue = {
  plantCode:'基地编码',
  plantName: '基地名称',
  createTime: '创建时间',
  queueNo:'排队编码',

  msg: {
  }
};
export default vehicleQueue



// WEBPACK FOOTER //
// ./src/page/bd/vehicleQueues/lang/vehicleQueues.en.js